import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchCards } from "../api";
import IMAGES from "../data/imageMap";

export default function FeaturedRow() {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    fetchCards("featured")
      .then((data) => setCards(Array.isArray(data) ? data : []))
      .catch(() => setCards([]));
  }, []);

  return (
    <section data-testid="featured-row" className="bg-white pb-16 md:pb-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex gap-4 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory scrollbar-hide -mx-4 md:mx-0 px-4 md:px-0">
          {cards.map((card) => {
            const to = card.slug ? `/featured/${card.slug}` : null;
            const Cmp = to ? Link : "div";
            const cmpProps = to ? { to } : {};
            return (
              <Cmp
                key={card.id}
                {...cmpProps}
                data-testid={`featured-card-${card.order}`}
                className={`group min-w-[78%] md:min-w-0 snap-start rounded-2xl bg-white border border-neutral-200 overflow-hidden transition-all duration-200 ${
                  to ? "cursor-pointer hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]" : ""
                }`}
              >
                <div className="aspect-[16/10] w-full overflow-hidden bg-neutral-100">
                  <img
                    src={IMAGES.featured[card.order]}
                    alt=""
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-[18px] font-semibold tracking-tight text-neutral-900 leading-snug">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-[14px] text-neutral-600 leading-relaxed line-clamp-3">
                    {card.blurb}
                  </p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-[14px] font-medium text-neutral-900">
                    {card.cta || "Learn more"}
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                  </div>
                </div>
              </Cmp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
